<template>
  <div ref="detailsPageRootRef" class="campaigns-details">
    <breadcrumbs :breadcrumbsData="breadcrumbsData">
      <template #icon>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-a-PaidPlacement" style="color: #fff;"></use>
        </svg>
      </template>
    </breadcrumbs>
    <div class="content">
      <notJoin v-if="joinedByMe === 'false'"/>
      <join v-else-if="joinedByMe === 'true'" />
    </div>
  </div>
</template>
<script setup>
import join from './components/join.vue';
import notJoin from './components/notJoin.vue';

import breadcrumbs from '@/components/breadcrumbs.vue'
import { useRoute } from 'vue-router'
import { computed, nextTick, onMounted, ref, watch } from 'vue'
const route = useRoute()
const detailsPageRootRef = ref(null)
const joinedByMe = computed(() => String(route.query.joinedByMe ?? ''))

function scrollCampaignDetailsToTop() {
  const zero = (el) => {
    if (el instanceof Element) {
      el.scrollTop = 0
      el.scrollLeft = 0
    }
  }
  const run = () => {
    const root = detailsPageRootRef.value
    if (root) {
      zero(root.closest('.publisher .right > .content'))
      zero(root.closest('.publisher .content'))
      zero(root.closest('.publisher'))
      zero(root.closest('.ant-spin-container'))
      let node = root.parentElement
      while (node) {
        zero(node)
        node = node.parentElement
      }
      root.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' })
    }
    zero(document.documentElement)
    zero(document.body)
    window.scrollTo(0, 0)
  }
  nextTick(() => {
    run()
    nextTick(run)
    requestAnimationFrame(() => {
      run()
      requestAnimationFrame(run)
    })
    setTimeout(run, 0)
    setTimeout(run, 120)
    setTimeout(run, 350)
  })
}

onMounted(() => {
  scrollCampaignDetailsToTop()
})

watch(
  () => route.fullPath,
  () => {
    scrollCampaignDetailsToTop()
  },
  { flush: 'post' },
)
const breadcrumbsData = computed(() => ({
  title: 'Campaign Details',
  hasTitleIcon: false,
  links: [
    {
      name: 'Home',
      path: '/publisher/campaigns',
    },
    {
      name: 'Campaigns',
      path: '/publisher/campaigns/index',
    },
    {
      name: 'Open CPC Campaigns',
      path: '/publisher/campaigns/index',
    },
    {
      name: 'Campaign Details',
      path: `/publisher/campaigns/details/${route.params.id}?joinedByMe=${encodeURIComponent(String(route.query.joinedByMe ?? ''))}`,
    },
  ],
}))
</script>